import { HttpErrorResponse } from '@angular/common/http';

/** Whether a save failed because the organisation withholds this action from a farmer-only user (C2027-196). */
export function isFarmerActionForbidden(error: unknown): boolean {
  return (
    error instanceof HttpErrorResponse && error.status === 403 && error.error?.errorCode === 'farmer_action_forbidden'
  );
}
